import {Injectable} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {TranslateService} from "bos-commons";


@Injectable({
    providedIn: 'root',
})
export class AlertService {

    constructor(private toastr: ToastrService, private translateService: TranslateService) {
    }

    error(messageKey: string, args?: string[]) {
        this.toastr.error(
            this.translateService.translateWithArgs(messageKey, args),
            this.translateService.translateWithArgs('title.error'));
    }

    success(messageKey: string, args?: string[]) {
        this.toastr.success(
            this.translateService.translateWithArgs(messageKey, args),
            this.translateService.translateWithArgs('title.success'));
    }

    warn(messageKey: string, args?: string[]) {
        this.toastr.warning(
            this.translateService.translateWithArgs(messageKey, args,),
            this.translateService.translateWithArgs('title.warning'));
    }

    info(messageKey: string, args?: string[]) {
        this.toastr.info(
            this.translateService.translateWithArgs(messageKey, args),
            this.translateService.translateWithArgs('title.info'));
    }

  infoWithoutTitle(messageKey: string, args?: string[]) {
    this.toastr.info(
      this.translateService.translateWithArgs(messageKey, args),
      '');
  }
}
